import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { ExchangeCalculateState, ExchangeCalculateContextActionTypes } from './types';
import { defaultExchangeCalculateState } from './defaultState';

const ExchangeCalculateContext = createContext<Partial<ExchangeCalculateState>>(defaultExchangeCalculateState);
const ExchangeCalculateDispatchContext = createContext<
  Dispatch<PayloadAction<ExchangeCalculateContextActionTypes, any>> | undefined
>(undefined);

export { ExchangeCalculateContext, ExchangeCalculateDispatchContext };
